import { gql } from "@apollo/client";

export const NEARBY_AVAILABILITY = gql`
  query nearbyAvailability($data: AvailableTimesInputV2!) {
    nearbyAvailability(data: $data) {
      otherMetroAvailableTimes {
        availableTimes {
          date
          times {
            time
            resourcesId
          }
        }
        location {
          idLocation
          locationName
          address
          city
          position {
            lat
            lng
          }
          email
          phoneNumber
          totalDistance
        }
        timeZone
        success
        messages
        totalDistance
      }
    }
  }
`;
